export default {"src":"/_next/static/media/road1.92c222a5.svg","height":206,"width":206,"blurWidth":0,"blurHeight":0};